exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-padding[data-v-322db210]{padding-top:12px;padding-bottom:12px}.upcoming-post[data-v-322db210]{position:relative;overflow:hidden}.upcoming-post[data-v-322db210]:after{content:\"\";position:absolute;top:0;bottom:0;left:0;width:4px;background-color:var(--bgColor)}.tag-font-size[data-v-322db210]{font-size:1rem}@media (max-width:768px){.tag-font-size[data-v-322db210]{font-size:.75rem}}.title-font-size[data-v-322db210]{font-size:1.25rem}@media (max-width:768px){.title-font-size[data-v-322db210]{font-size:1rem}}", ""]);

// exports
